<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="edit-user-tab"
            data-bs-toggle="tab"
            data-bs-target="#edit-user-tab-pane"
            type="button"
            role="tab"
            aria-controls="edit-user-tab-pane"
            aria-selected="true"
          >
            Informations Générales
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="bank-tab"
            data-bs-toggle="tab"
            data-bs-target="#bank-tab-pane"
            type="button"
            role="tab"
            aria-controls="bank-tab-pane"
            aria-selected="false"
          >
            Coordonnées bancaires
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#city-fees-tab"
            type="button"
            role="tab"
            aria-controls="city-fees-tab"
            aria-selected="false"
          >
            Personnaliser les frais d'une ville
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="contact-tab"
            data-bs-toggle="tab"
            data-bs-target="#contact-tab-pane"
            type="button"
            role="tab"
            aria-controls="contact-tab-pane"
            aria-selected="false"
          >
            Personnaliser les frais
          </button>
        </li>

        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="permissions-tab"
            data-bs-toggle="tab"
            data-bs-target="#permissions-tab-pane"
            type="button"
            role="tab"
            aria-controls="permissions-tab-pane"
            aria-selected="false"
          >
            Permissions
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="edit-user-tab-pane"
          role="tabpanel"
          tabindex="0"
        >
          <form @submit.prevent="handleSubmit" class="mt-40">
            <div class="row">
              <!-- Profile Image -->
              <div class="col-md-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10">
                  Photo de profil
                </label>
                <div class="d-flex align-items-center">
                  <img
                    v-if="imagepreview"
                    :src="imagepreview"
                    class="rounded-circle me-15"
                    style="width: 90px; height: 90px; object-fit: cover"
                  />
                  <img
                    v-else
                    :src="require('@/assets/images/NoImage.png')"
                    class="rounded-circle me-15"
                    style="width: 90px; height: 90px; object-fit: cover"
                  />
                  <div>
                    <input
                      ref="updateImgInput"
                      type="file"
                      accept="image/*"
                      class="d-none"
                      @change="logoSelected"
                    />
                    <button
                      type="button"
                      class="btn btn-primary me-2"
                      @click="() => updateImgInput?.click()"
                    >
                      Choisir la photo
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="cancelImage"
                    >
                      Annuler
                    </button>
                  </div>
                </div>
              </div>

              

              <!-- Nom complet -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Nom complet *</label
                >
                <input
                  v-model="customerData.name"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="Nom complet"
                  required
                />
              </div>

              <!-- CIN -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >CIN *</label
                >
                <input
                  v-model="customerData.cin"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="CIN"
                  required
                />
              </div>

              <!-- Pièces Jointes -->
              <div class="col-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >(Pièces Jointes) CIN</label
                >
                <input
                  type="file"
                  class="form-control shadow-none rounded-0"
                  @change="fileSelected"
                  multiple
                  accept="image/*"
                />
                <div
                  v-for="(attachment, index) in attachments"
                  :key="index"
                  class="mt-2"
                >
                  <span class="badge bg-primary">
                    {{ attachment.name }} ({{
                      (attachment.size / 1024 / 1024).toFixed(1)
                    }}MB)
                  </span>
                </div>
                <div class="mt-2">
                  <img
                    v-for="(url, index) in urls"
                    :key="index"
                    :src="url"
                    class="me-2 mb-2"
                    style="width: 120px; height: 120px; object-fit: cover"
                  />
                  <button
                    v-if="urls.length > 0"
                    type="button"
                    class="btn btn-warning rounded-circle"
                    @click="removeFiles"
                  >
                    X
                  </button>
                </div>
              </div>

              <!-- Adresse electronique -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Adresse electronique *</label
                >
                <input
                  v-model="customerData.email"
                  type="email"
                  class="form-control shadow-none rounded-0"
                  placeholder="Adresse electronique"
                  required
                />
                <small class="text-danger" v-if="erroremail"
                  >Email éléctronique déja existe</small
                >
              </div>

              <!-- Nom du magasin -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Nom du magasin *</label
                >
                <input
                  v-model="customerData.store"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="Nom du magasin"
                  required
                />
                <small class="text-danger" v-if="errorstore"
                  >Magazin déja existe</small
                >
              </div>

              <!-- Numéro de téléphone -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Numéro de téléphone *</label
                >
                <input
                  v-model="customerData.phone"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="Numéro de téléphone"
                  required
                />
                <small class="text-danger" v-if="errorphone"
                  >Ce numéro téléphone déja existe</small
                >
              </div>

              <!-- Numéro de téléphone personnel -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Numéro de téléphone (Personnel)</label
                >
                <input
                  v-model="customerData.phone_personal"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="Numéro de téléphone (Personnel)"
                />
              </div>

              <!-- Mot de passe -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Mot de passe *</label
                >
                <input
                  v-model="customerData.password"
                  type="password"
                  class="form-control shadow-none rounded-0"
                  placeholder="Mot de passe"
                />
              </div>

              <!-- Confirmation de mot de passe -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Confirmation de mot de passe *</label
                >
                <input
                  v-model="customerData.c_password"
                  type="password"
                  class="form-control shadow-none rounded-0"
                  placeholder="Confirmation de mot de passe"
                />
              </div>

              <!-- Ville -->
              <div class="col-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Ville *</label
                >
                <select
                  v-model="customerData.city_id"
                  class="form-select shadow-none rounded-0"
                  required
                >
                  <option v-for="(c, i) in citiesList" :key="i" :value="c.id">
                    {{ c.name }}
                  </option>
                </select>
              </div>

              <!-- Adresse -->
              <div class="col-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Adresse *</label
                >
                <textarea
                  v-model="customerData.address"
                  rows="2"
                  class="form-control shadow-none rounded-0"
                  placeholder="Adresse"
                  required
                ></textarea>
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Site web *</label
                >
                <input
                  v-model="customerData.website"
                  type="url"
                  class="form-control shadow-none rounded-0"
                  placeholder="Site web *"
                />
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Marque *</label
                >
                <input
                  v-model="customerData.brand"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="Marque *"
                />
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Type d'entereprise *</label
                >
                <select
                  v-model="customerData.id_type"
                  class="form-select shadow-none rounded-0"
                  required
                >
                  <option v-for="(c, i) in typeClients" :key="i" :value="c.id">
                    {{ c.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Registre de commerce</label
                >
                <input
                  v-model="customerData.rc"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="Registre de commerce"
                />
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Bloquer ajout des colis *</label
                >
                <select
                  v-model="customerData.block_add_parcel"
                  class="form-select shadow-none rounded-0"
                  required
                >
                  <option value="1">Oui</option>
                  <option value="0">Non</option>
                </select>
              </div>

              <div class="col-md-6 mb-20">
                <section class="payout-days">
                  <div class="payout-days__head">
                    <span>Jours de virement</span>
                    <span class="payout-days__count">{{ payoutDays.length }} / {{ WEEK_DAYS.length }}</span>
                  </div>
                  <label
                    v-for="day in WEEK_DAYS"
                    :key="day.value"
                    class="payout-day"
                    :class="{ 'is-on': payoutDays.includes(day.value) }"
                  >
                    <span class="payout-day__name">{{ day.label }}</span>
                    <input
                      type="checkbox"
                      class="payout-day__input"
                      role="switch"
                      :checked="payoutDays.includes(day.value)"
                      :disabled="payoutDays.length === 1 && payoutDays.includes(day.value)"
                      @change="toggleDay(day.value)"
                    />
                    <span class="payout-day__switch" aria-hidden="true"></span>
                  </label>
                  <small class="text-muted">Jours choisis par le client pour recevoir ses virements.</small>
                </section>
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10">
                  Message WhatsApp Meta
                </label>
                <div class="d-flex align-items-center gap-3 mt-2">
                  <div
                    class="form-check form-check-inline"
                    v-for="opt in [{ label: 'Oui', value: '1' }, { label: 'Non', value: '0' }]"
                    :key="opt.value"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="`wtsp_${opt.value}`"
                      :value="opt.value"
                      v-model="customerData.meta_wtsp_msg"
                    />
                    <label
                      class="form-check-label fw-medium"
                      :class="opt.value === '1' ? 'text-success' : 'text-danger'"
                      :for="`wtsp_${opt.value}`"
                    >
                      {{ opt.label }}
                    </label>
                  </div>
                </div>
              </div>
              <hr class="mb-40" />

              <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Pack tarifaire</label
                >
                <select
                  v-model="customerData.pack_id"
                  class="form-select shadow-none rounded-0"
                >
                  <option :value="null">Aucun (tarifs par défaut)</option>
                  <option v-for="(p, i) in packsList" :key="i" :value="p.id">
                    {{ p.name }}
                  </option>
                </select>
                <small class="text-muted"
                  >Si un pack est affecté, ses frais remplacent les frais
                  personnalisés ci-dessous.</small
                >
              </div>

              <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Frais de livraison personnalisé</label
                >
                <input
                  class="form-control shadow-none rounded-0"
                  type="number"
                  min="0"
                  id="delivered_price"
                  v-model="customerData.delivered_price"
                  placeholder="Frais de livraison personnalisé"
                />
              </div>
              <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Frais de retour personnalisé</label
                >
                <input
                  class="form-control shadow-none rounded-0"
                  type="number"
                  min="0"
                  id="returned_price"
                  v-model="customerData.returned_price"
                  placeholder="Frais de retour personnalisé"
                />
              </div>
              <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Frais de refus personnalisé</label
                >
                <input
                  class="form-control shadow-none rounded-0"
                  type="number"
                  min="0"
                  id="refused_price"
                  v-model="customerData.refused_price"
                  placeholder="Frais de refus personnalisé"
                />
              </div>

              <div v-if="auth.can('REFUND_FEES')" class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Frais de remboursement personnalisé</label
                >
                <input
                  class="form-control shadow-none rounded-0"
                  type="number"
                  min="0"
                  step="0.01"
                  id="refund_fees"
                  v-model="customerData.refund_fees"
                  :placeholder="'Frais généraux : ' + generalRefundFees"
                />
                <small class="text-muted"
                  >Vide = les frais généraux ({{ generalRefundFees }}) s'appliquent. 0 = gratuit pour ce client.</small
                >
              </div>

              <div v-if="auth.can('PACKAGING_FEES')" class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Frais d'emballage personnalisé</label
                >
                <input
                  class="form-control shadow-none rounded-0"
                  type="number"
                  min="0"
                  step="0.01"
                  id="packaging_fees"
                  v-model="customerData.packaging_fees"
                  :placeholder="'Frais généraux : ' + generalPackagingFees"
                />
                <small class="text-muted"
                  >Vide = les frais généraux ({{ generalPackagingFees }}) s'appliquent. 0 = gratuit pour ce client.</small
                >
              </div>

              <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Frais Stock</label
                >
                <input
                  class="form-control shadow-none rounded-0"
                  type="number"
                  min="0"
                  id="stock_fees"
                  v-model="customerData.stock_fees"
                  placeholder="Frais Stock"
                />
              </div>

              <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Frais Pour Colis remplacé</label
                >
                <input
                  class="form-control shadow-none rounded-0"
                  type="number"
                  min="0"
                  id="replace_fees"
                  v-model="customerData.replace_fees"
                  placeholder="Frais colis à ramplacé"
                />
              </div>

             <!-- <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Frais Colis Fragile</label
                >
                <input
                  class="form-control shadow-none rounded-0"
                  type="number"
                  min="0"
                  id="fragile_fees"
                  v-model="customerData.fragile_fees"
                  placeholder="Frais Fragile"
                />
              </div>-->

              <!-- <b-col
                    cols="12"
                    md="6"
                    > -->

              <!-- <div class="col-md-4 mb-20">
                  <label class="d-block text-black fw-semibold mb-10">Affichage Numero Livreur</label>
                    <select
                      v-model="customerData.livreur_show"
                      class="form-control"
                    >
                      <option value="1">Oui</option>
                      <option value="0">Non</option>
                    </select>
                  
                </div>

                <div class="col-md-4 mb-20">
                   <label class="d-block text-black fw-semibold mb-10">Ville de retour</label>
                    <v-select
                      id="city"
                      v-model="city_return"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="CitiesList"
                    >
                      
                    </v-select>
                  
                </div>

                <div class="col-md-4 mb-20">
                  <label class="d-block text-black fw-semibold mb-10">Ville de ramassage</label>
                    <v-select
                      id="city_pickup"
                      v-model="city_pickup"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="CitiesList"
                    />
                </div> -->

              <!-- Submit -->
              <div
                class="col-md-12 d-flex align-items-center justify-content-between mt-20"
              >
                <button type="submit" class="btn btn-success px-4 py-2">
                  Enregistrer
                  <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm ms-2"
                  ></span>
                </button>
                <button type="button" class="btn btn-link text-danger">
                  Annuler
                </button>
              </div>
            </div>
          </form>
        </div>
        <div
          class="tab-pane fade"
          id="bank-tab-pane"
          role="tabpanel"
          tabindex="0"
        >
          <form class="mt-40" @submit.prevent="saveBank">
            <div class="d-flex align-items-center justify-content-between mb-20">
              <h6 class="fw-bold mb-0"><i class="ph ph-bank me-2"></i>Coordonnées bancaires</h6>
              <button
                v-if="!bankEditing && canEditRib"
                type="button"
                class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
                @click="startBankEdit"
              >
                <i class="flaticon-pen"></i> Modifier
              </button>
            </div>

            <div class="row">
              <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10">RIB</label>
                <input
                  v-model="bankForm.rib"
                  type="text"
                  inputmode="numeric"
                  maxlength="24"
                  class="form-control shadow-none rounded-0"
                  placeholder="24 chiffres"
                  :disabled="!bankEditing"
                  @input="bankForm.rib = String(bankForm.rib || '').replace(/\D/g, '')"
                />
                <small v-if="bankEditing && bankForm.rib && bankForm.rib.length !== 24" class="text-danger">
                  Le RIB doit contenir 24 chiffres ({{ bankForm.rib.length }}/24)
                </small>
              </div>
              <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10">Nom du titulaire du compte</label>
                <input
                  v-model="bankForm.account_holder"
                  type="text"
                  maxlength="150"
                  class="form-control shadow-none rounded-0"
                  placeholder="Nom du titulaire"
                  :disabled="!bankEditing"
                />
              </div>
              <div class="col-md-4 mb-20">
                <label class="d-block text-black fw-semibold mb-10">Banque</label>
                <input
                  :value="detectedBank"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="Détectée automatiquement depuis le RIB"
                  disabled
                />
              </div>
            </div>

            <small v-if="!canEditRib" class="text-muted d-block mb-10">
              Vous n'avez pas la permission de modifier les coordonnées bancaires.
            </small>

            <div v-if="bankEditing" class="d-flex align-items-center gap-2 mt-10">
              <button type="submit" class="btn btn-success px-4 py-2" :disabled="bankSaving">
                Enregistrer
                <span v-if="bankSaving" class="spinner-border spinner-border-sm ms-2"></span>
              </button>
              <button type="button" class="btn btn-link text-danger" :disabled="bankSaving" @click="cancelBankEdit">
                Annuler
              </button>
            </div>
          </form>
        </div>
        <div
          class="tab-pane fade"
          id="city-fees-tab"
          role="tabpanel"
          tabindex="0"
        >
          <div class="card p-4 mt-20">
            <template v-if="citiesTarif.length > 0">
              <div
                v-for="item in citiesTarif"
                :key="item.id"
                class="row mb-3 border rounded p-3"
              >
                <!-- Ville -->
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Ville</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.name"
                      placeholder="Ville"
                      disabled
                    />
                  </div>
                </div>

                <!-- Frais -->
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label">Frais</label>
                    <input
                      type="number"
                      class="form-control"
                      v-model="item.delivered_fees"
                      placeholder="20"
                      disabled
                    />
                  </div>
                </div>

                <!-- Nouveau Frais -->
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label">Nouveau Frais</label>
                    <input
                      type="number"
                      class="form-control"
                      v-model="item.n_delivered_fees"
                      placeholder="15"
                    />
                  </div>
                </div>

                <!-- Remove Button -->
                <div class="col-md-4 d-flex align-items-end mb-3">
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    @click="removeCity(item)"
                  >
                    <i class="bi bi-x-lg me-1"></i> Supprimer
                  </button>
                </div>

                <div class="col-12">
                  <hr />
                </div>
              </div>
            </template>

            <form @submit.prevent="addCities">
              <div
                v-for="(item, index) in formItems"
                :key="index"
                class="row mb-3 border p-2 rounded"
              >
                <!-- Ville -->
                <div class="col-md-5">
                  <label class="form-label">Ville :</label>
                  <select
                    v-model="item.id"
                    class="form-select shadow-none rounded-0"
                    required
                    @input="(e) => updateItemForm(index, +(e.target as HTMLSelectElement).value)"
                  >
                    <option disabled value="">
                      -- Sélectionner une ville --
                    </option>
                    <option v-for="c in citiesList" :key="c.id" :value="c.id">
                      {{ c.name }}
                    </option>
                  </select>

                  <template
                    v-if="errorExist.exist && errorExist.error === index"
                  >
                    <small class="text-danger">Ville déjà sélectionnée</small>
                  </template>
                </div>

                <!-- Frais -->
                <div class="col-md-3">
                  <label class="form-label">Frais</label>
                  <input
                    v-model.number="item.delivered_fees"
                    type="number"
                    min="0"
                    class="form-control"
                    required
                    disabled
                  />
                </div>

                <!-- Nouveau Frais -->
                <div class="col-md-3">
                  <label class="form-label">Nouveau Frais</label>
                  <input
                    v-model.number="item.n_delivered_fees"
                    type="number"
                    min="0"
                    step="0.01"
                    class="form-control"
                    required
                    :disabled="errorExist.exist && errorExist.error === index"
                  />
                </div>

                <!-- Remove button -->
                <div class="col-md-1 d-flex align-items-end">
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    @click="removeItem(index)"
                    v-if="formItems.length > 1"
                  >
                    <i class="ph-duotone ph-trash"></i>
                  </button>
                </div>
              </div>

              <!-- Add Row -->
              <button
                type="button"
                class="btn btn-outline-primary me-2"
                @click="addItem"
              >
                <i class="ph ph-plus"></i> Nouvelle ville
              </button>

              <!-- Actions -->
              <div
                class="col-md-12 d-flex align-items-center justify-content-between mt-4"
              >
                <button type="submit" class="btn btn-success px-4 py-2">
                  Enregistrer
                </button>
              </div>
            </form>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="contact-tab-pane"
          role="tabpanel"
          tabindex="0"
        >
          <div class="row" v-for="(citie, index) in persoCities" :key="index">
            <!-- Frais actuel -->
            <div class="col-12 col-md-6 mb-3">
              <div class="mb-3">
                <label class="form-label">
                  Frais de ({{ citie.p_delivered_fees }})
                </label>
                <input
                  type="text"
                  class="form-control"
                  :value="citie.p_delivered_fees"
                  disabled
                />
              </div>
            </div>

            <!-- Nouveau frais -->
            <div class="col-12 col-md-6 mb-3">
              <div class="mb-3">
                <label class="form-label">Nouveau Frais</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="citie.n_delivered_fees"
                  placeholder="0"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-12 d-flex align-items-center justify-content-between mt-4"
            >
              <button
                type="button"
                @click="editFess"
                class="btn btn-success px-4 py-2"
              >
                Enregistrer
              </button>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade"
          id="permissions-tab-pane"
          role="tabpanel"
          tabindex="0"
        >
          <div class="row">
            <div class="col-lg-12">
              <div
                class="card mb-25 border-0 rounded-0 bg-white to-do-list-box"
              >
                <div
                  class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing"
                >
                  <ul class="to-do-list ps-0 list-unstyled mb-0">
                    <!-- Stock Client -->
                    <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task1"
                          @click="permStock()"
                          :checked="permsCust.stock == 1"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task1"
                        >
                          Stock Client
                        </label>
                      </div>
                    </li>

                    <!-- DropShippers -->
                    <!-- <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-info mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task2"
                          @click="permSupplier()"
                          :checked="permsCust.supplier == 1"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task2"
                        >
                          DropShippers
                        </label>
                      </div>
                    </li> -->

                    <!-- Black Liste -->
                    <!-- <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-danger mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task3"
                          @click="permBlackList()"
                          :checked="permsCust.black_list == 1"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task3"
                        >
                          Black Liste
                        </label>
                      </div>
                    </li> -->

                    <!-- Client Garantie -->
                    <!-- <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-success mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task4"
                          @click="permTrusted()"
                          :checked="permsCust.trusted == 1"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task4"
                        >
                          Client Garantie
                        </label>
                      </div>
                    </li> -->

                    <!-- Ajout des Colis -->
                    <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-warning mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task5"
                          @click="permAddParcel()"
                          :checked="permsCust.Parcels == 1"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task5"
                        >
                          Ajout des Colis
                        </label>
                      </div>
                    </li>

                    <!-- Importation Colis -->
                    <!-- <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-info mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task6"
                          @click="permImportParcel()"
                          :checked="permsCust.Import == 1"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task6"
                        >
                          Importation Colis
                        </label>
                      </div>
                    </li> -->

                    <!-- Exportation Colis -->
                    <!-- <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task7"
                          @click="permExportParcel()"
                          :checked="permsCust.Export == 1"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task7"
                        >
                          Exportation Colis
                        </label>
                      </div>
                    </li> -->

                    <!-- Gestion Stock -->
                    <!-- <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-success mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task8"
                          :checked="permsCust.self_stock == 1"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task8"
                        >
                          Gestion Stock
                        </label>
                      </div>
                    </li> -->

                    <!-- Store -->
                    <!-- <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-warning mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task9"
                          @click="PermMagasin()"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task9"
                        >
                          <div
                            class="icon-box d-flex align-items-center justify-content-center me-2"
                            :style="
                              permsCust.magasin == 1
                                ? {
                                    background:
                                      'linear-gradient(138deg, #da2c4d, #f8ab37)',
                                  }
                                : {}
                            "
                          >
                            <feather-icon
                              v-if="permsCust.magasin == 1"
                              icon="XIcon"
                              size="18"
                              class="mr-0"
                            />
                            <feather-icon
                              v-else
                              icon="CheckIcon"
                              size="18"
                              class="mr-0"
                            />
                          </div>
                          Store
                        </label>
                      </div>
                    </li> -->

                    <!-- Partenaire -->
                    <!-- <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-info mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task10"
                          @click="PermPartner()"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task10"
                        >
                          <div
                            class="icon-box d-flex align-items-center justify-content-center me-2"
                            :style="
                              permsCust.partner == 1
                                ? {
                                    background:
                                      'linear-gradient(138deg, #da2c4d, #f8ab37)',
                                  }
                                : {}
                            "
                          >
                            <feather-icon
                              v-if="permsCust.partner == 1"
                              icon="XIcon"
                              size="18"
                              class="mr-0"
                            />
                            <feather-icon
                              v-else
                              icon="CheckIcon"
                              size="18"
                              class="mr-0"
                            />
                          </div>
                          Partenaire
                        </label>
                      </div>
                    </li> -->

                    <!-- Applications -->
                    <!-- <li
                      class="to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="form-check form-check-danger mb-0 fs-md-15 fs-lg-16 text-black fw-medium"
                      >
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="task11"
                          :checked="permsCust.application == 1"
                        />
                        <label
                          class="form-check-label d-flex align-items-center"
                          for="task11"
                        >
                          Applications
                        </label>
                      </div>
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import api from "@/utils/axios";
import { computed, defineComponent, onMounted, reactive, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import Swal from "sweetalert2";
import { useAuthStore } from "@/stores/auth";
export default defineComponent({
  name: "EditCustomer",

  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  setup: (props) => {
    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const urls = ref<string[]>([]);
    const loading = ref(false);

    const errorname = ref(false);
    const errorstore = ref(false);
    const erroremail = ref(false);
    const errorphone = ref(false);

    const typeClients = ref<any[]>([]);
    const citiesList = ref<any[]>([]);
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    // general refund fees, shown next to the customer's own (needs REFUND_FEES)
    const generalRefundFees = ref<number | string>("—");
    // general packaging fees (BL stock), shown next to the customer's own (needs PACKAGING_FEES)
    const generalPackagingFees = ref<number | string>("—");
    (async () => {
      if (!auth.can("PACKAGING_FEES")) return;
      try {
        generalPackagingFees.value = (await api.get("/api/auth/bls/packaging-fees")).data.fees;
      } catch (e) {
        generalPackagingFees.value = "—";
      }
    })();
    onMounted(async () => {
      if (!auth.can("REFUND_FEES")) return;
      try {
        generalRefundFees.value = (await api.get("/api/auth/refund-requests/settings")).data.fees;
      } catch (e) {
        generalRefundFees.value = "—";
      }
    });
    const attachments = ref<File[]>([]);

    const customerData = reactive({
      name: "",
      cin: "",
      phone: "",
      email: "",
      password: "",
      c_password: "",
      phone_personal: "",
      address: "",
      store: "",
      city_id: null,
      attachments: [] as File[],
      logo: null as File | null,
      website: "",
      brand: "",
      rib: "",
      account_holder: "",
      bank: "",
      transfer_frequency: "weekly",
      id_type: null,
      rc: "",
      refused_price: null,
      returned_price: null,
      delivered_price: null,
      pack_id: null,
      stock_fees: null,
      replace_fees: null,
      refund_fees: null as number | string | null,
      packaging_fees: null as number | string | null,
      fragile_fees: null,
      block_add_parcel: "0",
      meta_wtsp_msg: "0",
    });

    const packsList = ref<any[]>([]);

    // Bank is detected from the 3 first digits of the RIB (same rule as the server)
    const banksList = ref<any[]>([]);
    const canEditRib = computed(() => auth.can("EDIT_CUSTOMER_RIB"));
    // Bank tab: read-only until "Modifier" is clicked, saved on its own endpoint
    const bankForm = reactive({ rib: "", account_holder: "" });
    const bankEditing = ref(false);
    const bankSaving = ref(false);
    const syncBankForm = () => {
      bankForm.rib = String(customerData.rib || "");
      bankForm.account_holder = String(customerData.account_holder || "");
    };
    const startBankEdit = () => {
      syncBankForm();
      bankEditing.value = true;
    };
    const cancelBankEdit = () => {
      syncBankForm();
      bankEditing.value = false;
    };
    const saveBank = async () => {
      if (bankForm.rib && bankForm.rib.length !== 24) {
        showToast("Le RIB doit contenir 24 chiffres", "error");
        return;
      }
      bankSaving.value = true;
      try {
        const res = await api.post(`/api/auth/customer_bank/${props.userId}`, {
          rib: bankForm.rib,
          account_holder: bankForm.account_holder,
        });
        if (res.data.message === "success") {
          customerData.rib = bankForm.rib;
          customerData.account_holder = bankForm.account_holder;
          bankEditing.value = false;
          showToast("Coordonnées bancaires mises à jour", "success");
        } else {
          showToast("Erreur lors de la mise à jour", "error");
        }
      } catch (err) {
        console.error(err);
        showToast("Erreur lors de la mise à jour", "error");
      } finally {
        bankSaving.value = false;
      }
    };

    const detectedBank = computed(() => {
      const digits = String(bankEditing.value ? bankForm.rib : customerData.rib || "").replace(/\D/g, "");
      if (digits.length < 3) return "";
      const b = banksList.value.find((x) => String(x.code) === digits.slice(0, 3));
      return b ? b.name : "Banque inconnue";
    });
    onMounted(async () => {
      try {
        banksList.value = (await api.get("/api/auth/banks")).data || [];
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    });

    onMounted(async () => {
      getCustomer();
      feesCustomer();
      permsCustomer();
      try {
        const response = await api.get("/api/auth/citiesList");
        if (response && response.data) {
          citiesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // zones
      try {
        const response = await api.get("/api/auth/typeClients");
        if (response && response.data) {
          typeClients.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      try {
        const response = await api.get("/api/auth/ListPacks");
        if (response && response.data) {
          packsList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching packs:", error);
      }
    });

    const logoSelected = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        customerData.logo = file; // use the 'file' variable instead of re-accessing target.files
        imagepreview.value = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    const fileSelected = (e: Event) => {
      const files = Array.from((e.target as HTMLInputElement).files || []);
      attachments.value = files;
      urls.value = files.map((f) => URL.createObjectURL(f));
    };

    const removeFiles = () => {
      attachments.value = [];
      urls.value = [];
    };

    const handleSubmit = async () => {
      if (customerData.password && customerData.password !== customerData.c_password) {
        showToast("Les mots de passe ne correspondent pas", "error");
        return;
      }

      const data = new FormData();
      if (customerData.password) {
        data.append("password", customerData.password);
        data.append("c_password", customerData.c_password);
      }
      data.append("id_type", customerData.id_type || "");
      // data.append("company_type", customerData.client_type.name);
      data.append("transfer_frequency", customerData.transfer_frequency);
      payoutDays.value.forEach((day) => data.append("payout_days[]", day));
      // data.append("bank", customerData.bank.name);
      // data.append("id_bank", customerData.bank.id);
      data.append("address", customerData.address);
      // data.append("city", customerData.city.name);
      data.append("city_id", customerData.city_id || "");
      data.append("email", customerData.email);
      data.append("phone", customerData.phone);
      data.append("phone_personal", customerData.phone_personal);
      data.append("cin", customerData.cin);
      data.append("name", customerData.name);
      data.append("logo", customerData.logo || "");
      // data.append("store", customerData.store);
      // data.append("store_id", customerData.market.id);
      // data.append("store_name", customerData.market.name);
      data.append("store", customerData.store);
      data.append("rc", customerData.rc);
      data.append("website", customerData.website);
      data.append("brand", customerData.brand);
      data.append("delivered_price", customerData.delivered_price || "");
      data.append("returned_price", customerData.returned_price || "");
      data.append("refused_price", customerData.refused_price || "");
      data.append("pack_id", customerData.pack_id || "");
      data.append("stock_fees", customerData.stock_fees || "");
      data.append("fragile_fees", customerData.fragile_fees || "");
      data.append("replace_fees", customerData.replace_fees || "");
      // empty = general fees; 0 is a real value (free)
      if (auth.can("PACKAGING_FEES")) {
        data.append("packaging_fees", customerData.packaging_fees === null || customerData.packaging_fees === undefined ? "" : String(customerData.packaging_fees));
      }
      if (auth.can("REFUND_FEES")) {
        data.append("refund_fees", customerData.refund_fees === null || customerData.refund_fees === undefined ? "" : String(customerData.refund_fees));
      }
      data.append("block_add_parcel", customerData.block_add_parcel || "");
      data.append("meta_wtsp_msg", customerData.meta_wtsp_msg);

      // replace_fees
      // data.append("livreur_show", customerData.livreur_show);
      // data.append(
      //   "city_return",
      //   customerData.city_return.id == null ? 0 : customerData.city_return.id
      // );
      // data.append(
      //   "city_pickup",
      //   customerData.city_pickup.id == null ? 0 : customerData.city_pickup.id
      // );

      try {
        loading.value = true;
        const res = await api.post(
          `/api/auth/customer_edit/${props.userId}`,
          data, {headers: { "Content-Type": "multipart/form-data" }});

        if (res.data.message === "success" || res.data.success) {
          showToast("Client mis à jour avec succès", "success");
          router.push("/customers-list");
        } else if (res.data.message === "not same") {
          showToast("Merci de verifier les mots de passe", "error");
        } else if (res.data.message === "email exist") {
          showToast("Cet email existe déjà", "error");
        } else {
          showToast("Erreur lors de l'ajout de l'utilisateur", "error");
        }
      } catch (err) {
        console.error("Error submitting form:", err);
      } finally {
        loading.value = false;
      }
    };

    // Transfer days (same model as the client profile)
    const WEEK_DAYS = [
      { value: "mon", label: "Lundi" },
      { value: "tue", label: "Mardi" },
      { value: "wed", label: "Mercredi" },
      { value: "thu", label: "Jeudi" },
      { value: "fri", label: "Vendredi" },
    ];
    const FREQUENCY_DAYS: Record<string, string[]> = {
      daily: ["mon", "tue", "wed", "thu", "fri"],
      three_times_week: ["mon", "wed", "fri"],
      weekly: ["mon"],
    };
    const payoutDays = ref<string[]>(["mon"]);
    // at least one day always stays selected
    const toggleDay = (day: string) => {
      if (payoutDays.value.includes(day)) {
        if (payoutDays.value.length > 1) payoutDays.value = payoutDays.value.filter((d) => d !== day);
      } else {
        payoutDays.value = WEEK_DAYS.map((d) => d.value).filter((d) => d === day || payoutDays.value.includes(d));
      }
    };

    const getCustomer = async () => {
      loading.value = true;
      try {
        const response = await api.get(
          `/api/auth/show_customer/${props.userId}`
        );
        if (response && response.data) {
          Object.assign(customerData, response.data);
          // chosen days, else the days of the legacy frequency
          const savedDays = String(response.data.payout_days || "")
            .split(",")
            .filter((d) => WEEK_DAYS.some((w) => w.value === d));
          payoutDays.value = savedDays.length
            ? savedDays
            : FREQUENCY_DAYS[response.data.transfer_frequency] || ["mon"];
          imagepreview.value = response.data.logo || null;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        loading.value = false;
      }
    };

    // fees city

    const persoCities = ref<any[]>([]);
    const citiesTarif = ref<any[]>([]);

    const feesCustomer = async () => {
      loading.value = true;
      try {
        const response = await api.get(
          `/api/auth/clientPerson/${props.userId}`
        );
        if (response && response.data) {
          persoCities.value = response.data.GroupTarif;
          citiesTarif.value = response.data.VilleTarif;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        loading.value = false;
      }
    };

    const formItems = ref([
      { id: "", delivered_fees: "", n_delivered_fees: "", name: "" },
    ]);

    const errorExist = ref({
      exist: false,
      error: 0,
    });

    const persoData = ref({
      cities: [...formItems.value],
    });

    const addItem = () => {
      formItems.value.push({
        id: "",
        name: "",
        delivered_fees: "",
        n_delivered_fees: "",
      });
    };

    const removeItem = (index: number) => {
      formItems.value.splice(index, 1);
      persoData.value.cities.splice(index, 1);
    };

    const updateItemForm = (index: number, selectedId: number) => {
      const city = citiesList.value.find((c) => c.id === selectedId);
      if (!city) return;

      errorExist.value.exist = false;
      errorExist.value.error = 0;

      // check if already exists
      const exists = persoData.value.cities
        .filter((_, i) => i !== index) // exclude current row
        .concat(citiesTarif.value)
        .find((o) => +o.id === selectedId);
      //   console.log(persoData, exists);

      if (exists) {
        errorExist.value.exist = true;
        errorExist.value.error = index;
      }

      // update formItems
      formItems.value[index].id = city.id;
      formItems.value[index].delivered_fees = city.delivered_fees || 0;
      formItems.value[index].n_delivered_fees = "";

      // sync with persoData
      persoData.value.cities[index] = {
        id: city.id,
        name: city.name || "",
        delivered_fees: city.delivered_fees || 0,
        n_delivered_fees: formItems.value[index].n_delivered_fees || "",
      };
    };

    async function removeCity(city) {
      const data = new FormData();
      data.append("id_city", city.id);
      Swal.fire({
        text: "Vous voulez supprimer cette ville ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await api.post(
              `/api/auth/removeCity/${props.userId}`,
              data
            );

            if (response.data === "success") {
              showToast("La ville est bien supprimée", "success");
              feesCustomer();
            } else {
              showToast("Erreur lors de la suppression de la ville !", "error");
            }
          } catch (error) {
            console.error(error);
            showToast("Une erreur est survenue !", "error");
          }
        }
      });
    }

    async function addCities() {
      //   console.log("Form submitted:", formItems.value);

      const data = new FormData();
      data.append(
        "PersoCities",
        JSON.stringify(formItems.value.concat(citiesTarif.value))
      );

      console.log(JSON.stringify(formItems.value.concat(citiesTarif.value)));

      const result = await Swal.fire({
        text: "Vous voulez modifier les frais de ces villes ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, Modifier!",
      });

      if (result.isConfirmed) {
        try {
          const response = await api.post(
            `/api/auth/EditCitiesFees/${props.userId}`,
            data
          );

          if (response.data === "success") {
            showToast("Les données sont bien enregistrés", "success");
            feesCustomer();

            // Reset first row (optional)
            // if (formItems.value.length > 0) {
            updateItemForm(0, 0); // or clear the id properly
            // Reset form
            formItems.value = [
              { id: "", delivered_fees: "", n_delivered_fees: "", name: "" },
            ];
            persoData.value.cities = [
              { id: "", delivered_fees: "", n_delivered_fees: "", name: "" },
            ];
            errorExist.value = { exist: false, error: 0 };

            // }
          } else {
            showToast("Erreur lors de la mise à jour", "error");
          }
        } catch (error) {
          console.error(error);
          showToast("Une erreur est survenue !", "error");
        }
      }
    }

    async function editFess() {
      const data = new FormData();
      data.append("PersoCities", JSON.stringify(persoCities.value));

      const result = await Swal.fire({
        text: "Vous voulez modifier ces frais ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, Modifier!",
      });

      if (result.isConfirmed) {
        try {
          const response = await api.post(
            `/api/auth/EditLivredFees/${props.userId}`,
            data
          );

          if (response.data === "success") {
            showToast("Les données sont bien enregistrées", "success");
            feesCustomer();
          }
        } catch (error) {
          console.error("Erreur lors de la modification des frais:", error);
          showToast("Une erreur est survenue", "error");
        }
      }
    }

    //  permissions customer
    const permsCust = ref<Record<string, any>>({});

    const permsCustomer = async () => {
      loading.value = true;
      try {
        const response = await api.get(
          `/api/auth/CustomerPerms/${props.userId}`
        );
        if (response && response.data) {
          permsCust.value = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        loading.value = false;
      }
    };

    // Generic function to toggle a permission
    async function togglePermission(endpoint) {
      const result = await Swal.fire({
        text: "Vous voulez modifier cette permission ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, modifier!",
        cancelButtonText: "Annuler",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`${endpoint}/${props.userId}`);
          if (res.data.message === "success") {
            showToast("Permission bien modifiée", "success");
            permsCustomer();
          }
        } catch (error) {
          console.error("Error updating permission:", error);
          showToast("Erreur lors de la modification", "error");
        }
      }
    }

    // Specific wrappers
    function permStock() {
      togglePermission("/api/auth/ActiveStockCust");
    }

    function permSupplier() {
      togglePermission("/api/auth/ActiveSuppCust");
    }

    function permBlackList() {
      togglePermission("/api/auth/ActiveBLCust");
    }

    function permTrusted() {
      togglePermission("/api/auth/ActivetrustedCust");
    }

    function permSelfStock() {
      togglePermission("/api/auth/ActiveSelfStockdCust");
    }

    function permImportParcel() {
      togglePermission("/api/auth/ActivePermImportParcel");
    }

    function permExportParcel() {
      togglePermission("/api/auth/ActivePermExportParcel");
    }

    function permAddParcel() {
      togglePermission("/api/auth/ActivePermAddParcel");
    }

    function permSms() {
      togglePermission("/api/auth/ActiveStoreCust");
    }

    function permPartner() {
      togglePermission("/api/auth/ActivePermPartner");
    }

    function permMagasin() {
      togglePermission("/api/auth/ActiveStore");
    }

    function permApps() {
      togglePermission("/api/auth/ActivePermApps");
    }
    return {
      auth,
      generalRefundFees,
      generalPackagingFees,
      WEEK_DAYS,
      payoutDays,
      canEditRib,
      detectedBank,
      bankForm,
      bankEditing,
      bankSaving,
      startBankEdit,
      cancelBankEdit,
      saveBank,
      toggleDay,
      updateImgInput,
      imagepreview,
      attachments,
      urls,
      customerData,
      citiesList,
      typeClients,
      packsList,
      loading,
      logoSelected,
      cancelImage,
      fileSelected,
      removeFiles,
      handleSubmit,

      errorname,
      errorstore,
      erroremail,
      errorphone,

      addItem,
      removeItem,
      addCities,
      formItems,
      citiesTarif,
      persoCities,
      removeCity,
      updateItemForm,
      errorExist,

      editFess,

      permsCust,
      permsCustomer,
      permStock,
      permSupplier,
      permBlackList,
      permTrusted,
      permExportParcel,
      permImportParcel,
      permAddParcel,
    };
  },
});
</script>

<style scoped>
.payout-days__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: 600;
  color: var(--ui-text);
}
.payout-days__count {
  padding: 2px 12px;
  border-radius: var(--ui-radius-sm, 6px);
  background: var(--ui-accent-soft);
  color: var(--ui-accent);
  font-variant-numeric: tabular-nums;
}
.payout-day {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  margin-bottom: 8px;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-sm, 6px);
  background: var(--ui-surface);
  cursor: pointer;
}
.payout-day__name {
  flex: 1;
  font-weight: 600;
  color: var(--ui-text);
}
.payout-day__input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.payout-day__switch {
  position: relative;
  flex: none;
  width: 44px;
  height: 24px;
  border-radius: 999px;
  background: var(--ui-border-strong, #adb5bd);
  transition: background 0.15s;
}
.payout-day__switch::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.15s;
}
.payout-day.is-on .payout-day__switch {
  background: var(--ui-accent);
}
.payout-day.is-on .payout-day__switch::after {
  transform: translateX(20px);
}
.payout-day__input:focus-visible + .payout-day__switch {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}
.payout-day__input:disabled + .payout-day__switch {
  opacity: 0.7;
}
</style>